import React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  LOCATIONS_PATH,
  LOCATION_OFFLINE_PATH,
  MENU_PATH
} from 'catering/constants/paths';

import {
  Layout,
  LocationsScreen,
  LocationOfflineScreen,
  MenuScreen
} from 'catering/screens';

import { usePrefetchCart, usePrefetchLocations } from 'catering/hooks/query';
import { usePageViews } from 'catering/hooks';
import { useHandleExternalPromotion } from 'catering/hooks/useHandleExternalPromotion';
import LocationAppBar from 'catering/components/Location/LocationAppBar';
import MenuAppBar from 'catering/components/Menu/MenuAppBar';
import { CateringMenuProvider } from 'catering/context/CateringMenuContext';
import CateringExternalPromotionToast from 'components/CateringExternalPromotionToast';

function AppRoutes() {
  const { isSuccess, error } = useHandleExternalPromotion();
  return (
    <Switch>
      <Route exact path={LOCATIONS_PATH}>
        <Layout AppBarComponent={LocationAppBar}>
          <LocationsScreen />
        </Layout>
      </Route>
      <Route exact path={LOCATION_OFFLINE_PATH}>
        <Layout AppBarComponent={LocationAppBar}>
          <LocationOfflineScreen />
        </Layout>
      </Route>
      <Route path={MENU_PATH}>
        <Layout AppBarComponent={MenuAppBar} paddingTop={0}>
          <CateringExternalPromotionToast error={error} isSuccess={isSuccess} />
          <CateringMenuProvider>
            <MenuScreen />
          </CateringMenuProvider>
        </Layout>
      </Route>
    </Switch>
  );
}

function App() {
  usePrefetchCart();
  usePrefetchLocations();
  usePageViews();
  useHandleExternalPromotion();

  return <AppRoutes />;
}

export default App;
